import { useKeycloak } from 'hooks/useKeyKloak'
import { createContext,ReactNode, useContext, useEffect, useState  } from 'react'
import { toast } from 'react-toastify'
import { SOCKET_TIME_OUT } from 'shared/constants/defaultENV'
import io, { Socket } from 'socket.io-client'

const TIME_OUT = 20 * 1000 // 20s

export const SocketContext = createContext(null as Socket | null)

type PropTypes = {
  children?: ReactNode
  socketUrl: string
}

const SocketProvider = (props: PropTypes) => {
  const { children, socketUrl } = props
  const { keycloak } = useKeycloak()
  const [socket, setSocket] = useState<null | ReturnType<typeof io>>(null)

  useEffect(() => {
    if (keycloak?.token)
      setSocket(
        io(socketUrl, {
          requestTimeout: TIME_OUT,
          timeout: TIME_OUT,
          autoConnect: true,
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionAttempts: 99999,
          auth: { token: keycloak?.token },
        })
      )

    return () => {
      if (socket) socket.close()
    }
  }, [keycloak?.token])

  useEffect(() => {
    const onError = () => {
      toast.dark('سرور در دسترس نمی باشد', {
        position: 'top-left',
        style: {
          fontFamily: 'dana, Nova, system-ui, sans-serif',
          boxShadow:
            'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
        },
        className: 'text-sm',
      })
    }

    if (socket) {
      socket.on('connect_error', onError)
    }

    if (!socket?.connect) {
      socket?.connect()
    }
  }, [socket])

  return (
    <SocketContext.Provider value={socket}>
      {socket?.connect ? children : null}
    </SocketContext.Provider>
  )
}

export const useSocketInstance = () => useContext(SocketContext)

export const useEmit = () => {
  const socket = useSocketInstance()

  function emitFunction<T = any>(...args: any): Promise<T> {
    return new Promise((resolve, reject) => {
      socket
        ?.timeout?.(SOCKET_TIME_OUT)
        .emit(...(args as [any]), (error?: any, data?: any) => {
          if (error) return reject(error)
          return resolve(data)
        })
    })
  }

  return emitFunction
}

export default SocketProvider
